import _ from "lodash";

import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { IntlActions, useTranslate } from "react-redux-multilingual";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollTop } from "components/standart";
import { clearWhatsAppMessage, setLocaleData, resetPlayer } from "actions";
import { frontendApi, userApi, authApi } from "reducers/api";
import { accessToken } from "reducers/api/token";
import BottomMenu from "components/common/bottom_menu";
import AuthTelegramWait from "views/auth/telegram-wait";
import { TelegramBackButtonOverload } from "components/standart/telegram-back-button";
import { history } from "store";
import WebApp from "@twa-dev/sdk";

import { YMInit } from "services";
import qs from "query-string";

import "components/common/index.scss";

// FBPixel.pageView();

const AppLayout = (props) => {
  const translate = useTranslate();

  const authStore = useSelector((state) => state.auth.auth);
  const player = useSelector((state) => state.player);
  const [renderIdent, setRenderIdent] = useState(Math.random());
  const [playerReady, setPlayerReady] = useState(null);

  useEffect(() => {
    if (!authStore.session) {
      //
    } else {
      props.resetPlayer(renderIdent);
      props.clearWhatsAppMessage();
    }

    return () => {
      props.resetPlayer();
    };
  }, [authStore.session]);

  useEffect(() => {
    scrollTop();

    setTimeout(function () {
      document.querySelector(".loader-wrapper").style = "display: none";
    }, 0);

    return () => {
      props.resetPlayer();
    };
  }, []);

  useEffect(() => {
    setPlayerReady(player.ident === renderIdent);
  }, [player.ident]);

  const sitename = () => {
    return _.get(props.env, "meta.sitename") || translate("meta_sitename");
  };

  return playerReady ? (
    <>
      <Helmet>
        <title>{sitename()}</title>
        <meta property="og:sitename" content={sitename()} />
        <meta property="og:site_name" content={sitename()} />
      </Helmet>

      <TelegramBackButtonOverload />

      {YMInit()}
      {/* <Header /> */}
      {props.children}
      {/* <Footer /> */}

      <div style={{ position: "relative" }}>
        <BottomMenu />
      </div>

      {/* 
      <CookieConsent
        background={"#000000"}
        bottomPosition={true}
        buttonText={translate("cookie_button")}
        buttonClassName="btn btn-solid white-btn"
        // buttonBackground={"#fff"}
        // buttonColor={"#000000"}
        // buttonFontSize={16}
        color={"#fff"}
        consentFunction={checkStatus}
        padding={20}
      >
        {translate("cookie_notice")}
      </CookieConsent>
       */}
    </>
  ) : null;
};

const mapStateToProps = (state) => ({
  userEnv: state.user.env,
  userSession: state.user.session,
  env: state.frontend.env,
  locales: state.locales,
});

export default connect(mapStateToProps, {
  resetPlayer,
  clearWhatsAppMessage,
})(AppLayout);
